export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/edit-63be6a722acafb1c1a92d7f892ed779c.svg";